"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameWatcher = exports.RoundWatcher = void 0;
function ignoreEvent() {
    /* do nothing */
}
class RoundWatcher {
    constructor(ctx, g, round, playerPath, handlers) {
        this.cleanups = {
            listenReady: ignoreEvent,
            listenGuess: ignoreEvent,
            listenLayout: ignoreEvent,
            listenBets: ignoreEvent,
            listenResults: ignoreEvent,
        };
        this.round = round;
        this.g = g;
        this.handlers = handlers;
        this.installListeners(ctx, playerPath);
    }
    installListeners(ctx, playerPath) {
        const cl = this.cleanups;
        const g = this.g;
        const r = this.round;
        cl.listenReady = r.listenForReadyPlayers(ctx, (ctx, readyPlayers, newPlayers) => {
            this.handlers.readyPlayers(g, r, readyPlayers, newPlayers);
        }, e => this.handlers.roundListenError(g, r, e));
        cl.listenGuess = r.listenForGuessPresence(ctx, playerPath, (ctx, present, newPlayers, myGuess) => {
            this.handlers.guessPresence(g, r, present, newPlayers, myGuess);
        }, e => this.handlers.roundListenError(g, r, e));
        cl.listenLayout = r.listenForGuessLayout(ctx, (ctx, layout) => {
            this.handlers.guessLayout(g, r, layout);
        }, e => this.handlers.roundListenError(g, r, e));
        cl.listenBets = r.listenForPlayerBets(ctx, (ctx, map, updatedPlayers) => {
            this.handlers.betUpdate(g, r, map, updatedPlayers);
        }, e => this.handlers.roundListenError(g, r, e));
        cl.listenResults = r.listenForRoundResults(ctx, (ctx, results) => {
            this.handlers.roundResults(g, r, results);
        }, e => this.handlers.roundListenError(g, r, e));
    }
    disconnect(_ctx) {
        Object.values(this.cleanups).forEach(cleanup => {
            cleanup();
        });
    }
}
exports.RoundWatcher = RoundWatcher;
// Watch a given Game.  Update rounds as they change,
class GameWatcher {
    constructor(ctx, playerPath, g, handlers) {
        // This is redundant with the Game.roundsCache[]?
        this.roundWatchers = []; // could be sparse
        this.cleanup = {
            completion: ignoreEvent,
            newRound: ignoreEvent,
        };
        this.g = g;
        this.playerPath = playerPath;
        this.handlers = handlers;
        this.g.forEachRound(ctx, r => {
            const rNum = r.getRoundNumber();
            ctx.assertUndefined(this.roundWatchers[rNum], 'Unexpected round visible at', rNum);
            this.roundWatchers[rNum] =
                new RoundWatcher(ctx, this.g, r, this.playerPath, this.handlers.roundEvents);
        });
        this.installListeners(ctx.newCtx('listeners'));
    }
    installListeners(ctx) {
        this.g.listenForJoinRequest(ctx, (playerPath, reqDoc) => {
            this.handlers.joinRequest(this.g, playerPath, reqDoc);
        }, e => this.handlers.gameListenError(this.g, e));
        this.cleanup.completion = this.g.listenForGameCompleted(ctx, () => {
            this.handlers.complete(this.g);
        }, e => this.handlers.gameListenError(this.g, e));
        this.installNewRoundListener(ctx);
    }
    installNewRoundListener(ctx) {
        this.cleanup.newRound = this.g.listenForNextRound(ctx, this.playerPath, newRound => {
            const roundNum = newRound.getRoundNumber();
            if (this.roundWatchers[roundNum]) {
                // Already seen this round. ignore it.
            }
            else {
                const logLabel = newRound.getRoundLabel(ctx);
                const rCtx = ctx.newCtx(logLabel);
                this.roundWatchers[roundNum] =
                    new RoundWatcher(rCtx, this.g, newRound, this.playerPath, this.handlers.roundEvents);
                this.handlers.newRound(this.g, newRound);
            }
        }, e => this.handlers.gameListenError(this.g, e));
    }
    latestRoundWatcher(_ctx) {
        const rnds = this.roundWatchers;
        const len = rnds.length;
        if (len === 0) {
            return undefined;
        }
        return rnds[len - 1];
    }
    disconnect(ctx) {
        this.cleanup.completion();
        this.cleanup.newRound();
        this.roundWatchers.forEach(rw => rw.disconnect(ctx));
    }
}
exports.GameWatcher = GameWatcher;
//# sourceMappingURL=GameWatcher.js.map